// extracted by mini-css-extract-plugin
module.exports =  {"root":"_0d624b9a27--root--fQAri","logo":"_0d624b9a27--logo--zdrPm","count":"_0d624b9a27--count--BIhrP","rest":"_0d624b9a27--rest--h7wS9"};